/**
 * Start screen (index.html): removed once the application is ready, but never
 * before the logo animation has played in full, so it is never cut short.
 * With reduced motion it leaves at once. The durations live in brand-loader.ts.
 */
import {
  STARTUP_ANIMATION_MS, STARTUP_FADE_MS, STARTUP_QUICK_MS, STARTUP_SEEN_KEY,
} from './brand-loader.js';

/** Time still owed to the animation, `elapsed` ms after the page started loading. */
export function remainingStartupMs(elapsed: number, quick: boolean, reducedMotion: boolean): number {
  if (reducedMotion) return 0;
  return Math.max(0, (quick ? STARTUP_QUICK_MS : STARTUP_ANIMATION_MS) - elapsed);
}

export function dismissLaunchScreen(): void {
  const launch = document.getElementById('launch');
  if (!launch || launch.classList.contains('brand-loader--out')) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const quick = launch.classList.contains('brand-loader--quick');
  try {
    // Later reloads of this session (refresh, update) replay the short version.
    window.sessionStorage.setItem(STARTUP_SEEN_KEY, '1');
  } catch {
    // Storage refused: every start simply plays the full animation.
  }
  window.setTimeout(() => {
    launch.classList.add('brand-loader--out');
    window.setTimeout(() => launch.remove(), reduced ? 0 : STARTUP_FADE_MS);
  }, remainingStartupMs(performance.now(), quick, reduced));
}
